import styled from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'

export const StyledLeasingSummaryText = styled.p`
    font-variation-settings: 'wght' 400;
    font-size: 14px;
    color: ${({ theme }) => theme.color.text.default};
    margin-left: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
    @media (min-width: 768px) {
        font-size: 16px;
    }
`
